<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-cogs</v-icon
              >
            </v-card>
            <div class="usuario">CONFIGURACION DE PUNTOS</div>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn dark class="botonplus" v-on="on"
                  ><v-icon color="white">mdi-plus-thick</v-icon></v-btn
                >
              </template>
              <v-card style="display: flex; flex-direction: column; max-height: 90vh;">
                <v-card-title class="nav" style="flex-shrink: 0;">
                  <span class="headline" style="color: whitesmoke"
                    ><v-icon color="white">mdi-cogs</v-icon>
                    {{ formTitle }}</span
                  >
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->
                <v-card-text style="flex: 1 1 auto; overflow-y: auto; min-height: 0;">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-autocomplete
                          v-model="editedItem.idEmpresa"
                          label="Empresa"
                          :items="empresas"
                          item-text="nombre"
                          item-value="idEmpresa"
                          :rules="[
                            (v) => !!v || 'Se requiere seleccionar una empresa',
                          ]"
                          required
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-autocomplete
                          persistent-hint
                          v-model="editedItem.idPunto"
                          label="Punto de Venta"
                          :items="puntosFiltrados"
                          item-value="idPunto"
                          :item-text="item => `${item.nombre} - ${item.nombreEmpresa || 'Sin Empresa'}`"
                        >
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                              <v-list-item-subtitle>
                                <span :style="{ color: item.idEmpresa == 1 ? '#1976d2' : item.idEmpresa == 2 ? '#d32f2f' : '#666' }">
                                  {{ item.nombreEmpresa || 'Sin Empresa' }}
                                </span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                          <template v-slot:selection="{ item }">
                            <span>{{ item.nombre }} - <strong>{{ item.nombreEmpresa || 'Sin Empresa' }}</strong></span>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem.ip"
                          label="IP"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem.equipo"
                          label="Equipo"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions style="flex-shrink: 0;">
                  <v-spacer></v-spacer>
                  <v-btn color="#1D3C7F" dark @click="close">Cancelar</v-btn>
                  <v-btn
                    color="#1D3C7F"
                    dark 
                    @click="save"
                    :disabled="
                      !editedItem.idEmpresa ||
                      !editedItem.idPunto ||
                      !editedItem.ip ||
                      !editedItem.equipo
                    "
                    >Guardar</v-btn
                  >
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
              </v-card>
            </v-dialog>
          </v-toolbar>
          <br />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar configuración"
            class="text-field"
            single-line
            color="#111c3d"
          ></v-text-field>
          <br />
          <!-- tabla donde se pintan los datos obtenidos del arreglo -->
          <v-data-table
            :headers="headers"
            :items="config"
            :search="search"
            style="border: 2px solid #111c3d"
            class="elevation-3"
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#294697"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#294697" depressed dark @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import swal from "sweetalert";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      puntos: [],
      empresas: [],
      config: [],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      dialog: false,
      headers: [
        {
          text: "IP",
          value: "ip",
          align: "center",
          class: "column",
        },
        {
          text: "Punto de Venta",
          align: "center",
          value: "nombre",
          class: "column",
        },
        {
          text: "Empresa",
          align: "center",
          value: "nombreEmpresa",
          class: "column",
        },
        {
          text: "equipo",
          value: "equipo",
          align: "center",
          class: "column",
        },
        {
          text: "Municipio",
          value: "direccion",
          align: "center",
          class: "column",
        },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      defaultItem: {
        id: "",
        idPunto: "",
        idEmpresa: "",
        ip: "",
        equipo: "",
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        idPunto: "",
        idEmpresa: "",
        ip: "",
        equipo: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva configuracion" : "Editar config";
    },
    puntosFiltrados() {
      if (!this.editedItem.idEmpresa) {
        return this.puntos;
      }
      return this.puntos.filter(punto => punto.idEmpresa == this.editedItem.idEmpresa);
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerPuntos();
    this.obtenerEmpresas();
    this.obtenerConfig();
  },

  methods: {
    // Metodo para obtener los puntos
    obtenerPuntos() {
      axios
        .get(`${env.endpoint}user/puntostodos`)
        .then((res) => (this.puntos = res.data));
    },

    // Metodo para obtener las empresas
    obtenerEmpresas() {
      axios.get(`${env.endpoint}user/empresas`).then((res) => {
        this.empresas = res.data;
      });
    },

    obtenerConfig() {
      axios
        .get(`${env.endpoint}user/configpuntos`)
        .then((res) => (this.config = res.data));
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.config.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // Si el item tiene idEmpresa, establecerlo. Si no, obtenerlo del punto
      if (!this.editedItem.idEmpresa && this.editedItem.idPunto) {
        const puntoSeleccionado = this.puntos.find(p => p.idPunto == this.editedItem.idPunto);
        if (puntoSeleccionado) {
          this.editedItem.idEmpresa = puntoSeleccionado.idEmpresa;
        }
      }
      this.dialog = true;
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    deleteItem(item) {
      swal({
        title: "Este registro sera eliminado permanentemente.",
        text: "Una vez eliminado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}user/delete_config?id=${item.id}`)
            .then((res) => {
              swal("Registro eliminado con exito!", {
                icon: "success",
              })
            })
            .then(otherProcess => {
              this.obtenerConfig();
            })
            .catch((error) => {
              this.text = "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas"
            });
        } else {
          swal("Proceso de eliminacion cancelado");
        }
      });
    },

    /**
     * Metodo para guardar y actualizar
     */
    save() {
      const nuevaConfig = JSON.stringify({
        idPunto: this.editedItem.idPunto,
        idEmpresa: this.editedItem.idEmpresa,
        ip: this.editedItem.ip,
        equipo: this.editedItem.equipo,
      });
      if (this.editedIndex == -1) {
        // se crea el usuario
        axios
          .get(`${env.endpoint}user/create_config?config=${nuevaConfig}`)
          .then((res) => {
            if (res.data.mensaje === "punto registrado") {
              this.text = "Configuracion de ip configurada satisfactoriamente";
              this.snackbar = true;
              this.obtenerConfig();
              this.close();
            } else if (res.data.mensaje === "error en el registro") {
              this.text = "Error al registrar";
              this.snackbar = true;
              this.close();
            } else if (res.data.mensaje === "error info existe") {
              this.text = "ERROR: El punto ya se encuentra registrado";
              this.snackbar = true;
              this.close();
            }
          })
          .catch((e) => {
            this.text =
              "Ha ocurrido un error inesperado si el problema persiste comuníquese con el área de sistemas";
            this.snackbar = true;
            this.close();
          });
      } else {
        let id = this.editedItem.id;
        axios
          .get(`${env.endpoint}user/edit_config?config=${nuevaConfig}&id=${id}`)
          .then((res) => {
            if (res.data.mensaje === "configuracion editada") {
              this.text = "Punto actualizado con exito";
              this.snackbar = true;
              this.obtenerConfig();
              this.close();
            } else if (res.data.mensaje === "error en el registro") {
              this.text = "Ha ocurrido un error, intente de nuevo";
              this.snackbar = true;
              this.close();
            }
          })
          .catch((e) => {
            this.text =
              "Ha ocurrido un error inesperado si el problema persiste comuniquese con el area de sistemas";
            this.snackbar = true;
            this.close();
          });
      }
    },
  },
};
</script>

<style>
/* Personalización de los colores de SweetAlert */
.swal-modal {
  background-color: #f4f7fa !important;
  border: 2px solid #294697 !important;
}
.swal-title {
  color: #294697 !important;
  font-weight: bold;
}
.swal-text {
  color: #1D3C7F !important;
}
.swal-button {
  background-color: #294697 !important;
  color: #fff !important;
  border-radius: 8px !important;
  font-weight: bold;
}
.swal-button--cancel {
  background-color: #fff !important;
  color: #294697 !important;
  border: 1px solid #294697 !important;
}
.swal-icon--warning {
  border-color: #294697 !important;
}
.swal-icon--warning__body, .swal-icon--warning__dot {
  background-color: #294697 !important;
}
</style>